import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SelectorArchivos, { subirEnSerie, avisaResultado, nombreDe } from "../../SelectorArchivos";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

function ListadoOrdenesCompra() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-91);

    let comp30 = new Date();
  comp30.setDate(comp30.getDate() -30 );
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  let compromiso30 = moment(comp30).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [artOC, setArtOC] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedFechaCompInicio, setSelectedFechaCompInicio] = useState("");
  const [selectedFechaCompFin, setSelectedFechaCompFin] = useState("");

  const [fecha, setFecha] = useState("");
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_cantidad, setTotalCantidad] = useState("");
  const [numero_orden, setNumeroOrden] = useState("");
  const [moneda, setMoneda] = useState("");
  // Editar OC: los mismos datos que el create
  const [monedaEdit, setMonedaEdit] = useState("");
  const [requisicionEdit, setRequisicionEdit] = useState("");
  const [condicionesPagoEdit, setCondicionesPagoEdit] = useState("");
  const [porcentajeAnticipoEdit, setPorcentajeAnticipoEdit] = useState("");
  const [monedaOriginalEdit, setMonedaOriginalEdit] = useState("");

  const [idEdit, setIdEdit] = useState("");

  // Archivos de la orden (proforma, BL, factura...)
  // Filtro de ordenes que el proveedor ya tiene listas
  const [filtroListo, setFiltroListo] = useState("");

  const [modalArchivos, setModalArchivos] = useState(false);
  const toggleArchivos = () => setModalArchivos(!modalArchivos);
  const [tipoArchivo, setTipoArchivo] = useState("Otro");
  // Numero de proforma capturable tambien desde el modal de archivos
  const [numeroProformaArch, setNumeroProformaArch] = useState("");
  const [diasEnvioArch, setDiasEnvioArch] = useState(0);
  const [ocArchivos, setOcArchivos] = useState({});
  const [listaArchivos, setListaArchivos] = useState([]);
  const [archivoNuevo, setArchivoNuevo] = useState([]);

  // Proforma del proveedor: numero, tiempo de envio y archivo adjunto
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const [numeroProforma, setNumeroProforma] = useState("");
  const [diasEnvio, setDiasEnvio] = useState(0);
  const [archivoProforma, setArchivoProforma] = useState([]);
  const [archivosOC, setArchivosOC] = useState([]);
  const [subiendoArchivo, setSubiendoArchivo] = useState(false);
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [modalEditArticulosPI, setModalEditArticulosPI] = useState(false);
  const toggleEditArticulosPI = () => setModalEditArticulosPI(!modalEditArticulosPI);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
  const [totalCaptura, setTotalCaptura] = useState(1);

  // const [inputFields, setInputFields] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      nombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  // Inicio / fin de produccion de la OC
  const [modalProduccion, setModalProduccion] = useState(false);
  const toggleProduccion = () => setModalProduccion(!modalProduccion);
  // D09 (checklist 21 OCT): dias de produccion de la OC, fin estimado automatico y carga lista
  const [diasProd, setDiasProd] = useState("");
  const [finManual, setFinManual] = useState(false);
  const [cargaListaProd, setCargaListaProd] = useState(false);
  const [inicioReal, setInicioReal] = useState("");
  const [obsProduccion, setObsProduccion] = useState("");
  const [finReal, setFinReal] = useState("");
  const [ocProduccion, setOcProduccion] = useState({});
  const [inicioProduccion, setInicioProduccion] = useState("");
  const [finProduccion, setFinProduccion] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [status, setStatus] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    const headersAuth = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    Promise.all([
      axios.get(
        `${URL_ORDENES_COMPRA}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers: headersAuth }
      ),
      // Los articulos de cada orden vienen agrupados desde el backend
      axios
        .get(`${process.env.REACT_APP_URL_ARTICULOS_OC}ResumenPorOrden`, {
          headers: headersAuth,
        })
        .catch((err) => {
          console.log(err);
          return { data: [] };
        }),
      // Anticipos de cada orden (solicitudes y pagos con concepto ANTICIPO)
      axios
        .get(`${URL_ORDENES_COMPRA}Anticipos`, { headers: headersAuth })
        .catch((err) => {
          console.log(err);
          return { data: [] };
        }),
    ])
      .then(([response, resumen, resumenAnticipos]) => {
        let allOrdenes = response.data;
        const anticipoPorOrden = {};
        (resumenAnticipos.data || []).forEach((r) => {
          anticipoPorOrden[String(r._id)] = r;
        });
        const porOrden = {};
        (resumen.data || []).forEach((r) => {
          porOrden[String(r._id)] = (r.articulos || [])
            .map((a) => `${a.SKU || a.nombre} (${new Intl.NumberFormat("en-US").format(a.cantidad)})`)
            .join(", ");
        });
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idOrdenCompra,
              activo: a.is_active,
              fecha: a.fecha,
              plazo: a.plazo,
              fecha_compromiso: a.fecha_compromiso,
              fechaInicioProduccion: a.fechaInicioProduccion || "",
              fechaFinProduccion: a.fechaFinProduccion || "",
              fechaInicioReal: a.fechaInicioReal || "",
              fechaFinReal: a.fechaFinReal || "",
              observacionesProduccion: a.observacionesProduccion || "",
              diasProduccion: a.diasProduccion || 0,
              fechaAnticipo: anticipoPorOrden[String(a._id)]?.fechaAnticipo || "",
              montoAnticipo: anticipoPorOrden[String(a._id)]?.montoPagado || 0,
              anticipoPagados: anticipoPorOrden[String(a._id)]?.pagados || [],
              anticipoPendiente: anticipoPorOrden[String(a._id)]?.fechaPendiente || "",
              anticipoPendienteEstado: anticipoPorOrden[String(a._id)]?.estadoPendiente || "",
              anticipoPendientes: anticipoPorOrden[String(a._id)]?.pendientes || [],
              devuelta: a.devuelta || "No",
              motivoDevolucion: a.motivoDevolucion || "",
              archivos: a.archivos || [],
              listoEmbarque: a.listoEmbarque || "No",
              fechaListoEmbarque: String(a.fechaListoEmbarque || "").slice(0, 10),
              articulos: porOrden[String(a._id)] || "",
              requisicion: a.requisicion || "",
              condicionesPago: a.condicionesPago || "",
              numeroProforma: a.numeroProforma || "",
              diasEnvio: a.diasEnvio || 0,
              observaciones: a.observaciones,
              total_general: a.total_general,
              proveedores: a.proveedores[0].nombre_comercial,
              idProveedores: a.proveedores[0]._id,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              idUser: a.user[0]._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              embarcado: a.embarcado,
              moneda: a.moneda,
              autorizado: a.autorizado,
              validado: a.validado,
              validadoPor: a.validadoPor || "",
              fechaValidacion: a.fechaValidacion || "",
              autorizadoPor: a.autorizadoPor || "",
              fechaAutorizacion: a.fechaAutorizacion || "",
              porcentajeAnticipo: a.porcentajeAnticipo || 0,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setOrdenesCompra(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, status]);


  function sumaDias(fecha, dias) {
    if (!fecha || !(Number(dias) > 0)) return "";
    const d = new Date(`${fecha}T12:00:00`);
    d.setDate(d.getDate() + Number(dias));
    return d.toISOString().slice(0, 10);
  }

  function abreProduccion(a) {
    setOcProduccion(a);
    setInicioProduccion(a.fechaInicioProduccion || "");
    setFinProduccion(a.fechaFinProduccion || "");
    setInicioReal(a.fechaInicioReal || "");
    setFinReal(a.fechaFinReal || "");
    setObsProduccion(a.observacionesProduccion || "");
    setCargaListaProd(a.listoEmbarque === "Si");
    // Si el fin ya no cuadra con inicio + dias, alguien lo puso a mano: se respeta
    setFinManual(!!a.fechaFinProduccion && sumaDias(a.fechaInicioProduccion, a.diasProduccion) !== a.fechaFinProduccion);
    setDiasProd(a.diasProduccion ? String(a.diasProduccion) : "");
    if (!a.diasProduccion) {
      // Sin dias en la OC: se propone el mayor de sus renglones (o del catalogo)
      axios
        .get(`${URL_ARTICULOS_OC}/ordenesCompra/${a._id}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        })
        .then((res) => {
          const mayor = Math.max(
            0,
            ...(res.data || []).map((l) => Number(l.diasProduccion || (l.articulos && l.articulos[0] && l.articulos[0].diasProduccion) || 0))
          );
          if (mayor > 0) setDiasProd(String(mayor));
        })
        .catch(() => {});
    }
    toggleProduccion();
  }

  function cambiaInicioEstimado(valor) {
    setInicioProduccion(valor);
    if (!finManual && Number(diasProd) > 0) setFinProduccion(sumaDias(valor, diasProd));
  }

  function cambiaDiasProd(valor) {
    if (valor !== "" && !(Number(valor) >= 0)) return;
    setDiasProd(valor);
    if (!finManual && inicioProduccion && Number(valor) > 0) setFinProduccion(sumaDias(inicioProduccion, valor));
  }

  // Acuerdo del 16 OCT: una fecha estimada vencida sin inicio real es atraso
  function atrasoProduccion(a) {
    const hoy = new Date().toISOString().slice(0, 10);
    if (a.fechaInicioProduccion && !a.fechaInicioReal && a.fechaInicioProduccion < hoy) {
      return "No ha iniciado y ya paso la fecha estimada de inicio";
    }
    if (a.fechaFinProduccion && !a.fechaFinReal && a.fechaFinProduccion < hoy) {
      return "No ha terminado y ya paso la fecha estimada de fin";
    }
    return "";
  }

  function guardaProduccion() {
    const hoy = new Date().toISOString().slice(0, 10);
    if (inicioProduccion && finProduccion && finProduccion < inicioProduccion) {
      Swal.fire({
        icon: "error",
        title: "Revisa las fechas",
        text: "La fecha de fin estimada no puede ser anterior a la de inicio",
      });
      return;
    }
    if (inicioReal && finReal && finReal < inicioReal) {
      Swal.fire({
        icon: "error",
        title: "Revisa las fechas",
        text: "La fecha de fin real no puede ser anterior a la de inicio real",
      });
      return;
    }
    if ((inicioReal && inicioReal > hoy) || (finReal && finReal > hoy)) {
      Swal.fire({
        icon: "error",
        title: "Esa fecha todavia no pasa",
        text: "Una fecha futura va en las estimadas, no en las reales.",
      });
      return;
    }
    axios
      .patch(
        `${URL_ORDENES_COMPRA}Produccion/${ocProduccion._id}`,
        {
          fechaInicioProduccion: inicioProduccion,
          fechaFinProduccion: finProduccion,
          fechaInicioReal: inicioReal,
          fechaFinReal: finReal,
          observacionesProduccion: obsProduccion,
          diasProduccion: Math.max(0, Number(diasProd) || 0),
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(async () => {
        // Carga lista desde el mismo modal (tiene su propio permiso y su propio aviso)
        let listo = null;
        const estabaLista = ocProduccion.listoEmbarque === "Si";
        if (user.oc_cargaLista && cargaListaProd !== estabaLista) {
          try {
            const r = await axios.patch(
              `${URL_ORDENES_COMPRA}ListoEmbarque/${ocProduccion._id}`,
              { listoEmbarque: cargaListaProd ? "Si" : "No", fecha: hoy, user: `${user.nombre} ${user.apellido}` },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            );
            listo = r.data || {};
          } catch (error) {
            Swal.fire({
              icon: "warning",
              title: "Se guardaron las fechas, pero no la carga lista",
              text: error.response?.data?.message || "",
            });
          }
        }
        axios.post(
          URL_LOGS,
          {
            tipo: "Produccion OC",
            detalle: `OC ${ocProduccion.numero} inicio ${inicioProduccion} fin ${finProduccion}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        setComments((anteriores) =>
          anteriores.map((x) =>
            x._id === ocProduccion._id
              ? {
                  ...x,
                  fechaInicioProduccion: inicioProduccion,
                  fechaFinProduccion: finProduccion,
                  fechaInicioReal: inicioReal,
                  fechaFinReal: finReal,
                  observacionesProduccion: obsProduccion,
                  diasProduccion: Math.max(0, Number(diasProd) || 0),
                  ...(listo
                    ? {
                        listoEmbarque: listo.listoEmbarque || "No",
                        fechaListoEmbarque: String(listo.fechaListoEmbarque || "").slice(0, 10),
                      }
                    : {}),
                }
              : x
          )
        );
        toggleProduccion();
        if (!(user.oc_cargaLista && cargaListaProd !== (ocProduccion.listoEmbarque === "Si") && !listo))
          Swal.fire("Listo", "Se guardaron los datos de produccion", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data || ""}`,
        });
      });
  }

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (filtroListo === "" ||
          (filtroListo === "Si" && a.listoEmbarque === "Si") ||
          (filtroListo === "No" && a.listoEmbarque !== "Si")) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.autorizado === "Si" ? "Si" : "No",
          a.listoEmbarque === "Si" ? "Si" : "No",
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          String(a.articulos || "").slice(0, 60),
          a.fechaInicioProduccion,
          a.fechaFinProduccion,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Autoriz.",
          "Carga Lista",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Articulos",
          "Inicio Prod",
          "Fin Prod",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Ordenes-Compra.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (filtroListo === "" ||
          (filtroListo === "Si" && a.listoEmbarque === "Si") ||
          (filtroListo === "No" && a.listoEmbarque !== "Si")) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Status: a.status,
          Autorizada: a.autorizado === "Si" ? "Si" : "No",
          CargaLista: a.listoEmbarque === "Si" ? `Si (${a.fechaListoEmbarque})` : "No",
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedor,
          Observaciones: a.observaciones,
          Articulos: a.articulos,
          FechaAnticipo: a.fechaAnticipo || (a.anticipoPendiente ? `${a.anticipoPendiente} (${a.anticipoPendienteEstado})` : ""),
          AnticipoPagado: a.montoAnticipo || 0,
          InicioProduccion: a.fechaInicioProduccion,
          ObsProduccion: a.observacionesProduccion || "",
          FinProduccion: a.fechaFinProduccion,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
          Moneda: a.moneda
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCompra";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCompra",
        sheetFilter: [
          "Status",
          "Autorizada",
          "CargaLista",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Articulos",
          "FechaAnticipo",
          "AnticipoPagado",
          "InicioProduccion",
          "FinProduccion",
          "ObsProduccion",
          "Cantidad",
          "Total",
          "Moneda",
        ],
        sheetHeader: [
          "Status",
          "Autorizada",
          "Carga Lista",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Articulos",
          "Fecha Anticipo",
          "Anticipo Pagado USD",
          "Inicio Produccion",
          "Fin Produccion",
          "Obs. Produccion",
          "Cantidad",
          "Total",
          "Moneda",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCompra.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Compra.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    total_cantidad,
    total_general,
    observaciones,
    numero_orden,
    idEdit
  ) {
    setFecha(fecha);
    setPlazo(plazo);
    setFechaCompromiso(fecha_compromiso);
    setSelectedProveedorEdit(idProveedores);
    setTotalCantidad(total_cantidad);
    setTotalGeneral(total_general);
    setObservaciones(observaciones);
    setNumeroOrden(numero_orden);
    setIdEdit(idEdit);
    const renglon = comments.find((x) => x._id === idEdit) || {};
    setMonedaEdit(renglon.moneda || "");
    setMonedaOriginalEdit(renglon.moneda || "");
    setRequisicionEdit(renglon.requisicion || "");
    setCondicionesPagoEdit(renglon.condicionesPago || "");
    setPorcentajeAnticipoEdit(renglon.porcentajeAnticipo ? String(renglon.porcentajeAnticipo) : "");
    toggleEdit();
  }

  async function ExcelOCMigracion(
    numero,
    idPDFOC,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              // Articulo: a.articulos[0].SKU,
              // Pack: a.pack,
              // TallasColores: a.tallasColores,
              // Cantidad: a.cantidad,
              // Precio: a.precio,
              // Total: a.total,
              articulosOrden: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              cantidadOC: a.cantidad,
              // costo: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
            sheetHeader: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // async function ExcelOCPI(
  //   numero,
  //   idPDFOC
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             IdItem: a._id,
  //             SKU: a.articulos[0].SKU,
  //             Nombre: a.articulos[0].nombre,
  //             Precio: a.precio,
  //             PiezasPorCaja: a.articulos[0].piezasPorCaja,
  //             CBM: a.cbm,
  //             Cajas: (a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2),
  //             Cantidad: a.cantidad,
  //             ValorTotal: a.cantidad * a.precio,
  //             TotalCBM: a.cbm * a.cantidad
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       var option = {};
  
  //       option.fileName = `OC-${numero}`;
    
  //       option.datas = [
  //         {
  //           sheetData: dataFinal,
  //           sheetName: `OC-${numero}`,
  //           sheetFilter: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //           sheetHeader: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //         },
  //       ];
    
  //       var toExcel = new ExportJsonExcel(option);
  //       toExcel.saveExcel();
       
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }


async function ExcelOCPI(numero, idPDFOC) {
  try {
    const response = await axios.get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data;
    let arrayTabla = allArticulosOrden.map((a) => {
      return {
        IdItem: a._id,
        SKU: a.articulos[0].SKU,
        Nombre: a.articulos[0].nombre,
        Precio: a.precio,
        PiezasPorCaja: a.articulos[0].piezasPorCaja,
        CBM: a.cbm,
        Cajas: parseFloat((a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2)),
        Moneda: a.ordenesCompra[0].proveedores[0].moneda,
        // Cantidad: a.cantidad,
        // ValorTotal: a.cantidad * a.precio,
        // TotalCBM: a.cbm * a.cantidad
      };
    }).filter(el => el != null);

    let dataFinal = arrayTabla.map((item, index) => ({
      ...item,
      // Aquí puedes definir las fórmulas en el formato de Excel
      Cantidad: { f: `E${index + 2} * G${index + 2}` },
      ValorTotal: { f: `D${index + 2} * H${index + 2}` }, // Ejemplo de fórmula
      TotalCBM: { f: `F${index + 2} * H${index + 2}` },
    }));

    let worksheet = XLSX.utils.json_to_sheet(dataFinal, {
      header: [
        "IdItem",
        "SKU",
        "Nombre",
        "Precio",
        "PiezasPorCaja",
        "CBM",
        "Cajas",
        "Cantidad",
        "ValorTotal",
        "TotalCBM",
        "Moneda",
      ]
    });

    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `OC-${numero}`);
    
    XLSX.writeFile(workbook, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}

async function ExcelOCPIIngles(numero, idPDFOC) {
  try {
    const response = await axios.get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data;
    let arrayTabla = allArticulosOrden.map((a) => {
      return {
        IdItem: a._id,
        SKU: a.articulos[0].SKU,
        Name: a.articulos[0].nombre,
        Price: a.precio,
        PicesPerBox: a.articulos[0].piezasPorCaja,
        CBM: a.cbm,
        Boxes: parseFloat((a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2)),
        Currency: a.ordenesCompra[0].proveedores[0].moneda,
        // Cantidad: a.cantidad,
        // ValorTotal: a.cantidad * a.precio,
        // TotalCBM: a.cbm * a.cantidad
      };
    }).filter(el => el != null);

    let dataFinal = arrayTabla.map((item, index) => ({
      ...item,
      // Aquí puedes definir las fórmulas en el formato de Excel
      Quantity: { f: `E${index + 2} * G${index + 2}` },
      TotalValue: { f: `D${index + 2} * H${index + 2}` }, // Ejemplo de fórmula
      TotalCBM: { f: `F${index + 2} * H${index + 2}` },
    }));

    let worksheet = XLSX.utils.json_to_sheet(dataFinal, {
      header: [
        "IdItem",
        "SKU",
        "Name",
        "Price",
        "PicesPerBox",
        "CBM",
        "Boxes",
        "Quantity",
        "TotalValue",
        "TotalCBM",
        "Currency",
      ]
    });

    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `OC-${numero}`);
    
    XLSX.writeFile(workbook, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}
  async function ExcelOC(
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              IdItem: a._id,
              SKU: a.articulos[0].SKU,
              Item: a.articulos[0].nombre,  
              OrderedPieces: a.cantidad,
              UnitPrice: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
            sheetHeader: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function PDFOC(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    proveedores,
    user,
    total_cantidad,
    total_general,
    moneda,
    observaciones,
    numero,
    idPDFOC,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].SKU + "  " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              // precio: a.precio,
              // total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              idArticulo: a.articulos[0]._id,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);


        dataFinal.map(async (z) => {
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
         await axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              if(data.data.secure_url != null){
              z.foto = data.data.secure_url
            }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
            })
            .catch((err) => {
              console.log(err);
            });
          return z
        })

        setTimeout(() => {

        const data = dataFinal.map((a) => {
          return [
            a.foto,
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            // "$" + new Intl.NumberFormat("en-US").format(a.precio),
            // "$" + new Intl.NumberFormat("en-US").format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 125, 10, 30, 30);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proveedor ${proveedores}`, 20, 30);
        doc.text(`Plazo ${plazo} días Compromiso ${fecha_compromiso}`, 20, 35);
        doc.text(`Piezas ${new Intl.NumberFormat("en-US").format(total_cantidad)}`, 20,40);
        doc.text(`Creado por ${user}`, 20, 45);
        // Requisicion y condiciones de pago de esta orden
        const ocPDF = comments.find((x) => x._id === idPDFOC) || {};
        if (ocPDF.requisicion) doc.text(`Requisicion ${ocPDF.requisicion}`, 20, 50);
        if (ocPDF.numeroProforma) doc.text(`Proforma ${ocPDF.numeroProforma}`, 90, 50);
        if (ocPDF.condicionesPago)
          doc.text(`Condiciones de pago: ${ocPDF.condicionesPago}`, 20, 55);
        doc.autoTable({
          columnStyles: {
            0: {
              fontSize: .0001,
              cellWidth: 25 // Ajusta el ancho de la primera columna (Foto)
            },
          },
          head: [[
            "Foto", 
            "Articulo", 
            "Cantidad", 
            // "Precio", 
            // "Total"
          ]],
          body: dataPDFLimpia,
          bodyStyles: {
            rowHeight: 22,
          },
          startY: 62,

          didDrawCell: function (data) {
            if (data.column.index === 0 && data.cell.section === "body") {
              var td = data.cell.raw;
              var img3 = td;
              //  var dim = data.cell.height - data.cell.padding('vertical');
              var textPos = data.cell;
              doc.addImage(img3, textPos.x, textPos.y, 20, 20);
            }
          },
          footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          // footStyles: {
          //   fontSize: 12,
          //   fillColor: [255,255,255],
          //   textColor: [0,0,0]
          // },
          // foot: [
          //   [
          //     "",
          //     "",
          //     "",
          //     "Total",
          //     "$" + new Intl.NumberFormat("en-US").format(total_general),
          //   ],
          // ],
          showFoot: "lastPage",
        });
        window.open(doc.output("bloburl"), "_blank");
//doc.save(`OC-${numero}.pdf`);
        
      }, 1000);

      })
      .catch((err) => {
        console.log(err);
      });
  }

    async function PDFOCCostos(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    proveedores,
    user,
    total_cantidad,
    total_general,
    moneda,
    observaciones,
    numero,
    idPDFOC,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].SKU + "  " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              idArticulo: a.articulos[0]._id,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);


        dataFinal.map(async (z) => {
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
         await axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              if(data.data.secure_url != null){
              z.foto = data.data.secure_url
            }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
            })
            .catch((err) => {
              console.log(err);
            });
          return z
        })

        setTimeout(() => {

        const data = dataFinal.map((a) => {
          return [
            a.foto,
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US").format(a.precio),
            "$" + new Intl.NumberFormat("en-US").format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 125, 10, 30, 30);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proveedor ${proveedores}`, 20, 30);
        doc.text(`Plazo ${plazo} días Compromiso ${fecha_compromiso}`, 20, 35);
        doc.text(`Piezas ${new Intl.NumberFormat("en-US").format(total_cantidad)}`, 20,40);
        doc.text(`Creado por ${user}`, 20, 45);
        // Requisicion y condiciones de pago de esta orden
        const ocPDF = comments.find((x) => x._id === idPDFOC) || {};
        if (ocPDF.requisicion) doc.text(`Requisicion ${ocPDF.requisicion}`, 20, 50);
        if (ocPDF.numeroProforma) doc.text(`Proforma ${ocPDF.numeroProforma}`, 90, 50);
        if (ocPDF.condicionesPago)
          doc.text(`Condiciones de pago: ${ocPDF.condicionesPago}`, 20, 55);
        doc.autoTable({
          columnStyles: {
            0: {
              fontSize: .0001,
              cellWidth: 25 // Ajusta el ancho de la primera columna (Foto)
            },
          },
          head: [[
            "Foto", 
            "Articulo", 
            "Cantidad", 
            "Precio", 
            "Total"
          ]],
          body: dataPDFLimpia,
          bodyStyles: {
            rowHeight: 22,
          },
          startY: 62,

          didDrawCell: function (data) {
            if (data.column.index === 0 && data.cell.section === "body") {
              var td = data.cell.raw;
              var img3 = td;
              //  var dim = data.cell.height - data.cell.padding('vertical');
              var textPos = data.cell;
              doc.addImage(img3, textPos.x, textPos.y, 20, 20);
            }
          },
          footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          // footStyles: {
          //   fontSize: 12,
          //   fillColor: [255,255,255],
          //   textColor: [0,0,0]
          // },
          foot: [
            [
              "",
              "",
              "",
              "Total",
              "$" + new Intl.NumberFormat("en-US").format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });
        window.open(doc.output("bloburl"), "_blank");
//doc.save(`OC-${numero}.pdf`);
        
      }, 1000);

      })
      .catch((err) => {
        console.log(err);
      });
  }


  function editOrdenes(event) {
    event.preventDefault();
    if (!selectedProveedorEdit || selectedProveedorEdit === "0") {
      Swal.fire({ icon: "error", title: "Selecciona el proveedor" });
      return;
    }
    if (!monedaEdit) {
      Swal.fire({ icon: "error", title: "Selecciona la moneda" });
      return;
    }
    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            fecha,
            // plazo es numerico en el backend: vacio no se manda
            ...(plazo === "" || plazo === undefined || plazo === null
              ? {}
              : { plazo: Number(plazo) || 0 }),
            fecha_compromiso,
            proveedores: selectedProveedorEdit,
            total_cantidad,
            total_general,
            observaciones,
            moneda: monedaEdit,
            requisicion: requisicionEdit,
            condicionesPago: condicionesPagoEdit,
            porcentajeAnticipo: parseFloat(porcentajeAnticipoEdit) || 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Orden deCompra",
            detalle: `${numero_orden} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Autorizada", field: "autorizado", sortable: true },
    { name: "Carga Lista", field: "listoEmbarque", sortable: true },
    { name: "Articulos", field: "articulos", sortable: true },
    { name: "Requisicion", field: "requisicion", sortable: true },
    { name: "Proforma", field: "numeroProforma", sortable: true },
    { name: "Fecha Anticipo", field: "fechaAnticipo", sortable: true },
    { name: "Fecha Comp Embarque", field: "fecha_compromiso", sortable: true },
    { name: "Inicio Produccion", field: "fechaInicioProduccion", sortable: true },
    { name: "Fin Produccion", field: "fechaFinProduccion", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Embarcado", field: "embarcado", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Moneda", field: "moneda", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      const txt = (v) => String(v === undefined || v === null ? "" : v).toLowerCase();
      const buscado = search.toLowerCase();
      computedComments = computedComments.filter(
        (comment) =>
          txt(comment.observaciones).includes(buscado) ||
          txt(comment.proveedores).includes(buscado) ||
          txt(comment.moneda).includes(buscado) ||
          txt(comment.articulos).includes(buscado) ||
          txt(comment.requisicion).includes(buscado) ||
          txt(comment.numeroProforma).includes(buscado) ||
          txt(comment.total_cantidad).includes(buscado) ||
          txt(comment.embarcado).includes(buscado) ||
          txt(comment.total_general).includes(buscado) ||
          txt(comment.numero).includes(buscado)
      );
    }
    if (filtroListo === "Si") {
      computedComments = computedComments.filter((e) => e.listoEmbarque === "Si");
    } else if (filtroListo === "No") {
      computedComments = computedComments.filter((e) => e.listoEmbarque !== "Si");
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedFechaCompInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso >= selectedFechaCompInicio
      );
    }

    if (selectedFechaCompFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso <= selectedFechaCompFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "embarcado" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    selectedProveedor,
    filtroListo,
  ]);
// console.log("hola", articulosOrden)
  function EditArticulos(idOC, numero_orden) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              // D08: dias de produccion de ESTA OC; si la linea no tiene, se propone el del catalogo
              diasProduccion: a.diasProduccion || a.articulos[0].diasProduccion || 0,
              diasProduccionOriginal: a.diasProduccion || a.articulos[0].diasProduccion || 0,
              diasProduccionCatalogo: a.articulos[0].diasProduccion || 0,
              diasProduccionLinea: a.diasProduccion || 0,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoCNY,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  // Marca que el proveedor ya tiene la mercancia lista. No crea el embarque.
  function marcaListoEmbarque(a) {
    const marcar = a.listoEmbarque !== "Si";
    Swal.fire({
      title: marcar
        ? `¿Marcar la OC ${a.numero} como lista para embarque?`
        : `¿Quitar la marca de la OC ${a.numero}?`,
      text: marcar
        ? "Solo avisa en el listado. El embarque se sigue creando aparte."
        : "",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: marcar ? "Si, esta lista" : "Si, quitar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_ORDENES_COMPRA}ListoEmbarque/${a._id}`,
          {
            listoEmbarque: marcar ? "Si" : "No",
            fecha: hoy,
            user: `${user.nombre} ${user.apellido}`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((res) => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Carga lista",
              detalle: `OC ${a.numero} ${marcar ? "lista" : "sin marca"}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          setComments((anteriores) =>
            anteriores.map((x) =>
              x._id === a._id
                ? {
                    ...x,
                    listoEmbarque: res.data?.listoEmbarque || "No",
                    fechaListoEmbarque: String(res.data?.fechaListoEmbarque || "").slice(0, 10),
                  }
                : x
            )
          );
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "No se pudo guardar",
            footer: `${error.response?.data || ""}`,
          });
        });
    });
  }

  function abreArchivos(a) {
    setOcArchivos(a);
    setListaArchivos(a.archivos || []);
    setArchivoNuevo([]);
    setNumeroProformaArch(a.numeroProforma || "");
    setDiasEnvioArch(a.diasEnvio || 0);
    toggleArchivos();
  }

  // Si el tipo es Proforma, el numero y los dias se guardan con la misma subida
  async function guardaNumeroDesdeArchivos() {
    const numero = String(numeroProformaArch || "").trim();
    const cambio =
      numero !== String(ocArchivos.numeroProforma || "") ||
      (parseFloat(diasEnvioArch) || 0) !== (parseFloat(ocArchivos.diasEnvio) || 0);
    if (!cambio) return true;
    try {
      await axios.patch(
        `${URL_ORDENES_COMPRA}Proforma/${ocArchivos._id}`,
        { numeroProforma: numero, diasEnvio: parseFloat(diasEnvioArch) || 0 },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const cambios = { numeroProforma: numero, diasEnvio: parseFloat(diasEnvioArch) || 0 };
      setOcArchivos((x) => ({ ...x, ...cambios }));
      setComments((anteriores) =>
        anteriores.map((x) => (x._id === ocArchivos._id ? { ...x, ...cambios } : x))
      );
      return true;
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar el numero de proforma",
        footer: `${error.response?.data?.message || error.response?.data || ""}`,
      });
      return false;
    }
  }

  // Sube un archivo a la orden; el backend lo guarda en la orden misma
  async function subeArchivoOC() {
    const esProforma = tipoArchivo === "Proforma" && user.oc_proforma;
    if (esProforma) {
      const numero = String(numeroProformaArch || "").trim();
      if (!numero && archivoNuevo.length) {
        const r = await Swal.fire({
          icon: "warning",
          title: "Falta el numero de proforma",
          text: "Sin el numero, la columna Proforma del listado queda vacia. ¿Subir sin numero?",
          showCancelButton: true,
          confirmButtonText: "Subir sin numero",
          cancelButtonText: "Capturar el numero",
        });
        if (!r.isConfirmed) return;
      }
      const ok = await guardaNumeroDesdeArchivos();
      if (!ok) return;
      // Solo se capturo el numero, sin archivo nuevo
      if (!archivoNuevo.length) {
        Swal.fire({ icon: "success", title: "Numero de proforma guardado" });
        return;
      }
    }
    if (!archivoNuevo.length) {
      Swal.fire({ icon: "error", title: "Elige primero los archivos o la carpeta" });
      return;
    }
    setSubiendoArchivo(true);
    const resultado = await subirEnSerie(
      archivoNuevo,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        formData.append("user", user.id);
        formData.append("tipo", tipoArchivo);
        return axios.post(`${URL_ORDENES_COMPRA}Archivo/${ocArchivos._id}`, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        });
      },
      `Subiendo a la OC ${ocArchivos.numero}`
    );
    setSubiendoArchivo(false);
    const nuevos = resultado.ultimaRespuesta?.data?.archivos;
    if (nuevos) {
      setListaArchivos(nuevos);
      setComments((anteriores) =>
        anteriores.map((x) => (x._id === ocArchivos._id ? { ...x, archivos: nuevos } : x))
      );
    }
    // Los que fallaron se quedan en la lista para reintentar
    setArchivoNuevo(archivoNuevo.filter((f) => resultado.fallidos.some((x) => x.nombre === nombreDe(f))));
    avisaResultado(resultado, "Quedaron en los archivos de la orden.");
  }


  // Trae los archivos que ya se subieron a esta orden
  function cargaArchivosOC(idOC) {
    axios
      .get(`${process.env.REACT_APP_URL_FINDMEDIABYTAG}/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => setArchivosOC(data.data?.resources || []))
      .catch((err) => {
        console.log(err);
        setArchivosOC([]);
      });
  }

  // Sube el archivo de la proforma y lo deja ligado a la orden
  async function guardaArchivoProforma() {
    if (!archivoProforma.length) {
      Swal.fire({ icon: "error", title: "Elige primero el archivo de la proforma" });
      return;
    }
    setSubiendoArchivo(true);
    const resultado = await subirEnSerie(
      archivoProforma,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        formData.append("user", user.id);
        // Se marca como Proforma: una ficha tecnica adjunta no cuenta como proforma
        formData.append("tipo", "Proforma");
        return axios.post(`${URL_ORDENES_COMPRA}Archivo/${idEdit}`, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        });
      },
      "Subiendo la proforma"
    );
    setSubiendoArchivo(false);
    const nuevos = resultado.ultimaRespuesta?.data?.archivos;
    if (nuevos) {
      setComments((anteriores) =>
        anteriores.map((x) => (x._id === idEdit ? { ...x, archivos: nuevos } : x))
      );
      cargaArchivosOC(idEdit);
    }
    setArchivoProforma(archivoProforma.filter((f) => resultado.fallidos.some((x) => x.nombre === nombreDe(f))));
    avisaResultado(resultado, "Quedan marcados como Proforma dentro de los archivos de la orden.");
  }


  // Guarda numero de proforma y tiempo de envio sin tocar el resto de la orden
  // Guarda la proforma en un solo paso: numero, dias de envio y archivo(s).
  // Antes eran dos botones y era facil subir el archivo sin guardar el numero.
  async function guardaProforma() {
    const numero = String(numeroProforma || "").trim();
    const ocActual = comments.find((x) => x._id === idEdit) || {};
    const datosCambiaron =
      numero !== String(ocActual.numeroProforma || "") ||
      (parseFloat(diasEnvio) || 0) !== (parseFloat(ocActual.diasEnvio) || 0);
    if (!datosCambiaron && !archivoProforma.length) {
      Swal.fire({ icon: "info", title: "No hay nada nuevo que guardar" });
      return;
    }
    if (!numero && archivoProforma.length) {
      const r = await Swal.fire({
        icon: "warning",
        title: "Falta el numero de proforma",
        text: "Sin el numero, la columna Proforma del listado queda vacia. ¿Guardar el archivo sin numero?",
        showCancelButton: true,
        confirmButtonText: "Guardar sin numero",
        cancelButtonText: "Capturar el numero",
      });
      if (!r.isConfirmed) return;
    }
    if (datosCambiaron) {
      try {
        await axios.patch(
          `${URL_ORDENES_COMPRA}Proforma/${idEdit}`,
          { numeroProforma: numero, diasEnvio: parseFloat(diasEnvio) || 0 },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        setComments((anteriores) =>
          anteriores.map((x) =>
            x._id === idEdit
              ? { ...x, numeroProforma: numero, diasEnvio: parseFloat(diasEnvio) || 0 }
              : x
          )
        );
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "No se pudieron guardar los datos de la proforma",
          footer: `${error.response?.data?.message || error.response?.data || ""}`,
        });
        return;
      }
    }
    if (archivoProforma.length) {
      await guardaArchivoProforma();
    } else {
      Swal.fire({ icon: "success", title: "Datos de la proforma guardados" });
    }
  }

  function EditArticulosPI(idOC, numero_orden, moneda) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    setMoneda(moneda);
    const ocActual = comments.find((x) => x._id === idOC);
    setNumeroProforma(ocActual?.numeroProforma || "");
    setDiasEnvio(ocActual?.diasEnvio || 0);
    setArchivoProforma([]);
    cargaArchivosOC(idOC);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoCNY,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulosPI();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let PR =
          parseFloat(i.pendiente_embarcar) -
          parseFloat(i.cantidad) +
          parseFloat(event.target.value);
        i.pendiente_embarcar = PR;
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const elegido = articulos.find((a) => a._id === idArticulo);
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.diasProduccion = (elegido && elegido.diasProduccion) || 0;
        i.diasProduccionOriginal = i.diasProduccion;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        let FOB = a.costoUSD;
        let nombre = a.nombre;
        handleChangeInputArticulo(id, idArticulo, FOB, nombre, a.diasProduccion || 0);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, nombre, diasProduccion) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.nombre = nombre;
        i.diasProduccion = diasProduccion || 0;
        i.diasProduccionOriginal = diasProduccion || 0;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.precio = FOB;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Dias de produccion del articulo, editables desde la OC
  function cambiaDiasProduccion(id, valor, esNuevo) {
    const actualiza = (lista) =>
      lista.map((i) => (i.id === id ? { ...i, diasProduccion: valor } : i));
    if (esNuevo) setInputFields(actualiza(inputFields));
    else setArticulosOrden(actualiza(articulosOrden));
  }

  // D08 (checklist 21 OCT): los dias se guardan en la LINEA de esta OC, no en el
  // catalogo maestro. Los renglones nuevos los llevan en su alta.
  async function guardaDiasProduccion() {
    const cambios = new Map();
    articulosOrden.forEach((i) => {
      if (
        i.id &&
        i.diasProduccionOriginal !== undefined &&
        i.diasProduccion !== "" &&
        Number(i.diasProduccion) !== Number(i.diasProduccionOriginal)
      ) {
        cambios.set(i.id, Math.max(0, Number(i.diasProduccion) || 0));
      }
    });
    for (const [idLinea, dias] of cambios) {
      await axios.patch(
        `${URL_ARTICULOS_OC}/${idLinea}`,
        { diasProduccion: dias },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
    }
    if (cambios.size) {
      axios.post(
        URL_LOGS,
        {
          tipo: "Dias de produccion",
          detalle: `OC ${numero_orden}: dias de produccion de ${cambios.size} renglon(es)`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
    }
    return cambios.size;
  }

  function ActualizaTotales() {
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    toggleProgreso();
    try {
      await guardaDiasProduccion();
    } catch (error) {
      toggleProgreso();
      Swal.fire({
        icon: "error",
        title: "No se pudieron guardar los dias de produccion",
        footer: `${error.response?.data?.message || error.message}`,
      });
      return;
    }

    let totalArticulos = inputFields.length + articulosOrden.length;

    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            total_general: total_general_edit,
            total_cantidad: total_cantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_OC,
                  {
                    ordenesCompra: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    embarcado: 0,
                    pendiente_embarcar: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                    diasProduccion: Math.max(0, Number(a.diasProduccion) || 0),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Editar Orden de Compra",
                          detalle: `${numero_orden}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response?.data?.message || error.response?.data || ""}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response?.data?.message || error.response?.data || ""}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Editar Orden de Compra",
                      detalle: `${numero_orden}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response?.data?.message || error.response?.data || ""}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosOrden.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                  // pendiente_embarcar: parseFloat(a.pendiente_embarcar),
                  ajusteAcumulado: parseFloat(a.cantidad - a.cantidadAnterior),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Orden de Compra",
                        detalle: `${numero_orden}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response?.data?.message || error.response?.data || ""}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data || ""}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function excelInfoArt() {

    axios
    .get(`${URL_ARTICULOS_OC}FindAllInfoArt`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allInfoArt = response.data;

      const dataExcel = allInfoArt.map((a) => {
          return {
            Articulo: a.codigo,
            Cantidad: a.cantidad,
            Embarcado: a.embarcado,
            PendienteEmbarcar: a.pendiente_embarcar,
          };
      });
      const dataExportExcel = Object.values(dataExcel);
      const dataExcelLimpia = dataExportExcel.filter(function (el) {
        return el != null;
      });
  
      var option = {};
  
      option.fileName = "Info Articulos OC";
  
      option.datas = [
        {
          sheetData: dataExcelLimpia,
          sheetName: "Info Articulos OC",
          sheetFilter: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
          sheetHeader: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
        },
      ];
  
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });

  
  }

  // Igual que en el backend: cuenta el numero capturado o un archivo marcado como Proforma
  function tieneProforma(a) {
    return !!(String(a.numeroProforma || "").trim() || (a.archivos || []).some((f) => f.tipo === "Proforma"));
  }

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Listo", "Orden autorizada. Se le aviso a Oyuki para solicitar el anticipo", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data || ""}`,
            });
            console.log(error);
          })
      }
    });
  }

  // Paso 02 del flujo: devolver la orden a quien la capturo, con motivo
  function devolver(a) {
    Swal.fire({
      title: `Devolver la OC ${a.numero}?`,
      input: "textarea",
      inputLabel: "Motivo de la devolucion",
      inputPlaceholder: "Que hay que corregir...",
      inputAttributes: { "aria-label": "Motivo" },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Devolver",
      cancelButtonText: "Cancelar",
      inputValidator: (valor) =>
        !valor || !valor.trim() ? "Escribe el motivo de la devolucion" : undefined,
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_ORDENES_COMPRA}Devolver/${a._id}`,
          { motivo: result.value, user: `${user.nombre} ${user.apellido}` },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((res) => {
          setComments((anteriores) =>
            anteriores.map((x) =>
              x._id === a._id
                ? {
                    ...x,
                    autorizado: "No",
                    validado: "No",
                    devuelta: "Si",
                    motivoDevolucion: res.data?.motivoDevolucion || result.value,
                  }
                : x
            )
          );
          Swal.fire("Listo", "Se devolvio la orden y se mando el aviso", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "No se pudo devolver",
            footer: `${error.response?.data?.message || error.response?.data || ""}`,
          });
        });
    });
  }

  function desautorizar(id) {
    Swal.fire({
      title: "Quitar la autorizacion?",
      text: "La orden regresa a pendiente de autorizar",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_COMPRA}/${id}`,
            { autorizado: "No" },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            Swal.fire("Listo", "Se quito la autorizacion", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

    function validar(id, numero) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Listo", "Proforma validada. Se le aviso a Sergio para que autorice", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data || ""}`,
            });
            console.log(error);
          })
      }
    });
  }

      function desvalidar(id, numero) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "La orden regresa a por validar (y si estaba autorizada, tambien pierde la autorizacion)",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Listo", "Se quito la validacion", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data || ""}`,
            });
            console.log(error);
          })
      }
    });
  }

  // Sube la PI que regresa el proveedor y actualiza los renglones de la OC.
  // Identifica cada fila por IdItem (la columna que trae el Excel que genera el
  // sistema) y, si el archivo no la tiene, por SKU. Una fila que no corresponde
  // a ningun renglon de esta orden se reporta y NO se agrega: antes se metia con
  // el articulo vacio y la orden tronaba al guardar.
  function importarArchivo(event) {
    const target = event.target;
    if (target.name !== "file" || !target.files || !target.files[0]) return;

    const limpia = (v) => String(v === undefined || v === null ? "" : v).trim();
    const numero = (v) => {
      const n = parseFloat(String(v === undefined || v === null ? "" : v).replace(/[^0-9.-]/g, ""));
      return isNaN(n) ? 0 : n;
    };
    // Lee una columna aceptando los nombres en espanol e ingles
    const campo = (fila, nombres) => {
      const llaves = Object.keys(fila);
      for (const n of nombres) {
        const llave = llaves.find((k) => k.trim().toLowerCase() === n.toLowerCase());
        if (llave !== undefined) return fila[llave];
      }
      return undefined;
    };

    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onloadend = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const filas = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]]
        );

        if (!filas.length) {
          Swal.fire({
            icon: "warning",
            title: "El archivo viene vacio",
            text: "La primera hoja del archivo no tiene renglones.",
          });
          target.value = "";
          return;
        }

        const nuevos = articulosOrden.map((x) => ({ ...x }));
        let actualizados = 0;
        const noEncontrados = [];

        filas.forEach((fila) => {
          const idItem = limpia(campo(fila, ["IdItem", "Id Item", "ID"]));
          const sku = limpia(campo(fila, ["SKU", "Sku", "Codigo", "Código"]));
          const cantidad = numero(campo(fila, ["Quantity", "Cantidad", "Qty", "OrderedPieces"]));
          const precio = numero(campo(fila, ["Price", "Precio", "UnitPrice", "Unit Price", "FOB"]));
          const cbm = numero(campo(fila, ["CBM", "Cbm"]));

          // Una fila sin datos utiles se ignora en silencio
          if (!idItem && !sku) return;

          let i = -1;
          if (idItem) i = nuevos.findIndex((x) => String(x.id) === idItem);
          if (i === -1 && sku)
            i = nuevos.findIndex(
              (x) => String(x.SKU || "").trim().toLowerCase() === sku.toLowerCase()
            );

          if (i === -1) {
            noEncontrados.push(sku || idItem);
            return;
          }

          const cantidadFinal = cantidad > 0 ? cantidad : nuevos[i].cantidad;
          const precioFinal = precio > 0 ? precio : nuevos[i].precio;
          nuevos[i] = {
            ...nuevos[i],
            cantidad: cantidadFinal,
            precio: precioFinal,
            total: cantidadFinal * precioFinal,
            cbm: cbm > 0 ? cbm : nuevos[i].cbm,
            pendiente_embarcar: cantidadFinal - (parseFloat(nuevos[i].embarcado) || 0),
          };
          actualizados++;
        });

        setArticulosOrden(nuevos);

        const cant = nuevos.map((c) => parseFloat(c.cantidad) || 0);
        setTotalCantidadEdit(cant.reduce((t, n) => t + n, 0));
        const importes = nuevos.map((c) => parseFloat(c.total) || 0);
        setTotalGeneralEdit(importes.reduce((t, n) => t + n, 0));

        if (!actualizados) {
          Swal.fire({
            icon: "error",
            title: "No se pudo leer la proforma",
            html: `Ningun renglon del archivo coincide con los articulos de esta orden.<br/><br/>
                   Descarga la PI con el boton <b>PI I</b>, pasale ese archivo al proveedor y sube el que te regrese:
                   trae la columna <b>IdItem</b> que amarra cada renglon.<br/>
                   Tambien funciona si el archivo trae una columna <b>SKU</b> con los SKU de esta orden.`,
          });
        } else {
          Swal.fire({
            icon: noEncontrados.length ? "warning" : "success",
            title: `Se actualizaron ${actualizados} renglones`,
            html: noEncontrados.length
              ? `No se encontraron en esta orden: <b>${noEncontrados.join(", ")}</b>.<br/>
                 Esos renglones no se agregaron. Si hay articulos nuevos, agregalos abajo con el buscador.<br/><br/>
                 Revisa los totales y presiona Guardar.`
              : "Revisa los totales y presiona Guardar.",
          });
        }
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "No se pudo leer el archivo",
          text: "Asegurate de que sea un Excel (.xlsx o .xls) y que los datos esten en la primera hoja.",
        });
      }
      target.value = "";
    };
  }


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.oc_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCompraCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  title="PDF del listado con los filtros que tienes puestos"
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  title="Mandar el listado por correo"
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  title="Excel del listado con los filtros que tienes puestos"
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  title="Excel con el detalle de articulos de cada orden"
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelInfoArt}
                >
                  Excel Info Art <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Compra</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.codigo} - {a.razon_social}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label>Status</Label>
              <Input
                bsSize="sm"
                type="select"
                value={status}
                required
                onChange={(e) => {
                  setStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label>Carga lista</Label>
              <Input
                bsSize="sm"
                type="select"
                value={filtroListo}
                onChange={(e) => {
                  setFiltroListo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="Si">Solo las listas</option>
                <option value="No">Solo las pendientes</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        (a.fecha_compromiso < endDate ||
                          a.fecha_compromiso < compromiso30) &&
                        a.status == "Abierto"
                          ? { backgroundColor: "#ed8c8c" }
                          : // : a.fechaCompromiso > compromiso30
                            // ? { backgroundColor: "#fcf260"  }
                            // : { backgroundColor: "#64e379" }
                            undefined
                      }
                    >
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.observaciones}</td>
                      <td>
                        {a.autorizado === "Si" ? (
                          <Badge
                            color="success"
                            pill
                            title={`Autorizada${a.autorizadoPor ? ` por ${a.autorizadoPor}` : ""}${a.fechaAutorizacion ? ` el ${a.fechaAutorizacion}` : ""}`}
                          >
                            Autorizada
                          </Badge>
                        ) : a.devuelta === "Si" ? (
                          <Badge color="danger" pill title={a.motivoDevolucion}>
                            Devuelta
                          </Badge>
                        ) : a.validado === "Si" ? (
                          <Badge
                            color="info"
                            pill
                            title={`Validada${a.validadoPor ? ` por ${a.validadoPor}` : ""}${a.fechaValidacion ? ` el ${a.fechaValidacion}` : ""}. Falta que Sergio la autorice`}
                          >
                            Por autorizar
                          </Badge>
                        ) : tieneProforma(a) ? (
                          <Badge color="warning" pill title="Ya tiene proforma. Falta que Compras la valide">
                            Por validar
                          </Badge>
                        ) : (
                          <Badge color="secondary" pill title="OC preliminar: falta que Diana cargue la proforma">
                            Sin proforma
                          </Badge>
                        )}
                      </td>
                      <td>
                        {a.listoEmbarque === "Si" ? (
                          <Badge color="success" pill title={`Carga lista desde ${a.fechaListoEmbarque}`}>
                            Carga lista
                          </Badge>
                        ) : (
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>—</span>
                        )}
                      </td>
                      <td style={{ fontSize: "12px", minWidth: "190px" }}>
                        {a.articulos}
                      </td>
                      <td>{a.requisicion}</td>
                      <td>
                        {a.numeroProforma ? (
                          a.numeroProforma
                        ) : (a.archivos || []).some((f) => f.tipo === "Proforma") ? (
                          <span
                            style={{ fontSize: 11, color: "#b45309" }}
                            title="Hay archivo de proforma pero no se capturo el numero"
                          >
                            <i class="fas fa-paperclip"></i> Sin numero
                          </span>
                        ) : null}
                      </td>
                      <td
                        style={{ fontSize: 12, minWidth: 110 }}
                        title={[
                          ...a.anticipoPagados.map((x) => `${x.fecha} · ${x.origen} · pagado ${x.monto}`),
                          ...a.anticipoPendientes.map((x) => `${x.fecha} · ${x.origen} · ${x.estado} ${x.monto}`),
                        ].join("\n")}
                      >
                        {a.fechaAnticipo ? (
                          <>
                            {a.fechaAnticipo}
                            <div style={{ fontSize: 10, color: "#15803d" }}>
                              Pagado{" "}
                              {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(a.montoAnticipo)}
                              {a.anticipoPagados.length > 1 ? ` (${a.anticipoPagados.length})` : ""}
                            </div>
                          </>
                        ) : a.anticipoPendiente ? (
                          <>
                            <span style={{ color: "#64748b" }}>{a.anticipoPendiente}</span>
                            <div style={{ fontSize: 10, color: "#b45309" }}>{a.anticipoPendienteEstado}</div>
                          </>
                        ) : (
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>—</span>
                        )}
                      </td>
                      <td>{a.fecha_compromiso}</td>
                      <td title={a.observacionesProduccion}>{a.fechaInicioProduccion}</td>
                      <td title={a.observacionesProduccion}>
                        {a.fechaFinProduccion}
                        {a.observacionesProduccion ? (
                          <i
                            class="far fa-comment-dots"
                            style={{ marginLeft: 5, color: "#64748b" }}
                            title={a.observacionesProduccion}
                          ></i>
                        ) : null}
                      </td>
                      <td>{a.proveedores}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.total_cantidad
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.embarcado)}
                      </td>
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.total_general
                          )}{" "}
                      </td>
                      <td>{a.moneda}</td>
                      <td style={{ minWidth: 184 }}>
                        {user.menu_compras ? (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 4,
                              alignItems: "center",
                            }}
                          >
                            {/* Checklist 21 OCT: proforma -> Compras valida -> Sergio autoriza */}
                            {user.oc_validar && a.autorizado !== "Si" ? (
                              a.validado === "Si" ? (
                                <Button
                                  title={`Validada${a.validadoPor ? ` por ${a.validadoPor}` : ""}. Click para quitar la validacion`}
                                  color="primary"
                                  onClick={(e) => desvalidar(a._id, a.numero)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              ) : tieneProforma(a) ? (
                                <Button
                                  title="Validar la proforma (le avisa a Sergio para que autorice)"
                                  color="warning"
                                  onClick={(e) => validar(a._id, a.numero)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              ) : (
                                <span title="No se puede validar: la orden todavia no tiene proforma">
                                  <Button color="secondary" size="sm" disabled style={{ pointerEvents: "none" }}>
                                    <i class="fas fa-thumbs-up"></i>
                                  </Button>
                                </span>
                              )
                            ) : undefined}
                            {user.oc_autorizar ? (
                              a.autorizado === "Si" ? (
                                <Button
                                  color="success"
                                  size="sm"
                                  title={`Autorizada${a.autorizadoPor ? ` por ${a.autorizadoPor}` : ""}. Click para quitar la autorizacion`}
                                  onClick={(e) => desautorizar(a._id)}
                                >
                                  <i class="fas fa-check-circle"></i>
                                </Button>
                              ) : a.validado === "Si" ? (
                                <Button
                                  color="warning"
                                  size="sm"
                                  title="Autorizar la orden (le avisa a Oyuki para solicitar el anticipo)"
                                  onClick={(e) => autorizar(a._id)}
                                >
                                  <i class="fas fa-check-circle"></i>
                                </Button>
                              ) : (
                                <span title="No se puede autorizar: Compras todavia no valida la proforma">
                                  <Button color="secondary" size="sm" disabled style={{ pointerEvents: "none" }}>
                                    <i class="fas fa-check-circle"></i>
                                  </Button>
                                </span>
                              )
                            ) : undefined}
                            {(user.oc_validar || user.oc_autorizar) && a.autorizado !== "Si" ? (
                              <Button
                                color="danger"
                                size="sm"
                                title={
                                  a.devuelta === "Si"
                                    ? `Devuelta: ${a.motivoDevolucion}`
                                    : "Devolver la orden para correccion"
                                }
                                onClick={(e) => devolver(a)}
                              >
                                <i class="fas fa-undo"></i>
                              </Button>
                            ) : undefined}
                          <Button
                            title="PDF de la orden de compra"
  size="sm"
  className="btn"
  color="danger"
  onClick={() =>
    user?.inventarios_costos
      ? PDFOCCostos(
          a.fecha,
          a.plazo,
          a.fecha_compromiso,
          a.idProveedores,
          a.proveedores,
          a.user,
          a.total_cantidad,
          a.total_general,
          a.moneda,
          a.observaciones,
          a.numero,
          a._id
        )
      : PDFOC(
          a.fecha,
          a.plazo,
          a.fecha_compromiso,
          a.idProveedores,
          a.proveedores,
          a.user,
          a.total_cantidad,
          a.total_general,
          a.moneda,
          a.observaciones,
          a.numero,
          a._id
        )
  }
>
  <i class="far fa-file-pdf"></i>
</Button>

                              {user.inventarios_costos ? (
                                <>
                                 <Button
                                   title="Excel de la orden de compra"
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOC(a.numero, a._id)}
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPI(a.numero, a._id)}
                            >
                              PI E
                            </Button> */}

                            <Button
                              title="PI en ingles para el proveedor (Excel)"
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPIIngles(a.numero, a._id)}
                            >
                              PI I
                            </Button>
                                </>
                              ): (
                                <>
                                 <span title="Excel de la orden. Requiere permiso de costos" style={{ display: "inline-block" }}><Button style={{ pointerEvents: "none" }}
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOC(a.numero, a._id)}
                              disabled
                            >
                              <i class="far fa-file-excel"></i>
                            </Button></span>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOCPI(a.numero, a._id)}
                              disabled
                            >
                              PI E
                            </Button> */}

                            <span title="PI en ingles. Requiere permiso de costos" style={{ display: "inline-block" }}><Button style={{ pointerEvents: "none" }}
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOCPIIngles(a.numero, a._id)}
                              disabled
                            >
                              PI I
                            </Button></span>
                                </>
                              )}
                           

                            {/* <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                            /> 
                             <BajaAltaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />*/}
                            {/* Paso 09 del flujo: CARGA LISTA (no crea el embarque, solo avisa) */}
                            {user.oc_cargaLista ? (
                              <Button
                                size="sm"
                                className="btn"
                                color={a.listoEmbarque === "Si" ? "success" : "light"}
                                title={
                                  a.listoEmbarque === "Si"
                                    ? `Carga lista desde ${a.fechaListoEmbarque}. Click para quitar la marca`
                                    : "Marcar CARGA LISTA"
                                }
                                onClick={() => marcaListoEmbarque(a)}
                              >
                                <i class="fas fa-ship"></i>
                              </Button>
                            ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color="secondary"
                              title="Archivos de la orden"
                              onClick={() => abreArchivos(a)}
                            >
                              <i class="fas fa-paperclip"></i>
                              {a.archivos && a.archivos.length
                                ? ` ${a.archivos.length}`
                                : ""}
                            </Button>
                            {/* Paso 08 del flujo: fechas de produccion */}
                            {user.oc_produccion ? (
                              <Button
                                size="sm"
                                className="btn"
                                color="success"
                                title="Inicio / fin de produccion"
                                onClick={() => abreProduccion(a)}
                              >
                                <i class="fas fa-industry"></i>
                              </Button>
                            ) : undefined}
                            <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={
                                process.env.REACT_APP_URL_ORDENES_COMPRA
                              }
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />
                          </div>
                        ) : undefined}
                      </td>
                      <td style={{ minWidth: 116 }}>
                        {a.status == "Abierto" && a.activo == "Si" ? (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 4,
                              alignItems: "center",
                            }}
                          >
                            {user.inventarios_costos ? (
                              <>
                                <Button
                                  title="Editar datos de la orden: fecha, plazo, compromiso y observaciones"
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    jalaInfo(
                                      a.fecha,
                                      a.plazo,
                                      a.fecha_compromiso,
                                      a.idProveedores,
                                      a.total_cantidad,
                                      a.total_general,
                                      a.observaciones,
                                      a.numero,
                                      a._id
                                    )
                                  }
                                >
                                  <i class="far fa-edit"></i>
                                </Button>
                                <Button
                                  title="Editar articulos: cantidades, precios y dias de produccion"
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => EditArticulos(a._id, a.numero)}
                                >
                                  <i class="fas fa-cart-plus"></i>
                                </Button>
                              </>
                            ) : undefined}
                            {/* Paso 03 del flujo: proforma del proveedor e importacion de la PI */}
                            {user.oc_proforma ? (
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                title="Proforma del proveedor"
                                onClick={(e) =>
                                  EditArticulosPI(a._id, a.numero, a.moneda)
                                }
                              >
                                PI
                              </Button>
                            ) : undefined}
                          </div>
                        ) : (
                          <div>
                            <span title="Editar datos. Solo con la orden abierta" style={{ display: "inline-block" }}><Button style={{ pointerEvents: "none" }} color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button></span>
                            <span title="Editar articulos. Solo con la orden abierta" style={{ display: "inline-block" }}><Button style={{ pointerEvents: "none" }} color="info" id="Editar" size="sm" disabled>
                              <i class="fas fa-cart-plus"></i>
                            </Button></span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Orden de Compra {numero_orden}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Autocomplete
                size="small"
                options={proveedores
                  .filter((p) => p.is_active !== "No" || p._id === selectedProveedorEdit)
                  .map((p) => ({
                    ...p,
                    junta: `${p.codigo || ""} ${p.nombre_comercial || ""} ${p.razon_social || ""}`.trim(),
                  }))
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))}
                value={
                  proveedores
                    .filter((p) => p._id === selectedProveedorEdit)
                    .map((p) => ({
                      ...p,
                      junta: `${p.codigo || ""} ${p.nombre_comercial || ""} ${p.razon_social || ""}`.trim(),
                    }))[0] || null
                }
                getOptionLabel={(option) => option.junta || ""}
                getOptionSelected={(option, valor) => option._id === valor._id}
                onChange={(event, valor) => setSelectedProveedorEdit(valor ? valor._id : "")}
                onKeyDown={(e) => {
                  // Enter no debe guardar el formulario por accidente
                  if (e.key === "Enter") e.preventDefault();
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" placeholder="Busca por codigo o nombre" />
                )}
              />
            </Col>
            <Col md={3}>
              <Label>Plazo (dias)</Label>
              <Input
                type="number"
                min="0"
                placeholder="Plazo"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Comp Embarque</Label>
              <Input
                type="date"
                placeholder="Fecha Comp Embarque"
                value={fecha_compromiso}
                required
                onChange={(e) => {
                  setFechaCompromiso(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <Label className="mr-sm-2">Moneda</Label>
              <Input
                type="select"
                value={monedaEdit}
                onChange={(e) => setMonedaEdit(e.target.value)}
              >
                <option value="">Selecciona</option>
                <option value="USD">USD</option>
                <option value="CNY">CNY</option>
                <option value="MXN">MXN</option>
                <option value="EUR">EUR</option>
              </Input>
              {monedaEdit && monedaOriginalEdit && monedaEdit !== monedaOriginalEdit ? (
                <div style={{ fontSize: 11, color: "#b45309", marginTop: 3 }}>
                  Cambiar la moneda no convierte los precios de los articulos.
                </div>
              ) : null}
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Requisicion</Label>
              <Input
                type="text"
                placeholder="Numero de requisicion"
                value={requisicionEdit}
                onChange={(e) => setRequisicionEdit(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">% Anticipo</Label>
              <Input
                type="number"
                min="0"
                max="100"
                step="any"
                placeholder="Ej. 30"
                title="Porcentaje del total que se paga de anticipo. Con el se calcula el monto de la solicitud de pago"
                value={porcentajeAnticipoEdit}
                onChange={(e) => {
                  const v = e.target.value;
                  if (v === "" || (parseFloat(v) >= 0 && parseFloat(v) <= 100)) setPorcentajeAnticipoEdit(v);
                }}
              />
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Condiciones de pago</Label>
              <Input
                type="text"
                placeholder="Ej. 30% anticipo, 70% contra copia de BL"
                value={condicionesPagoEdit}
                onChange={(e) => setCondicionesPagoEdit(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={4}>
              <h4 id="logoutBoton">
              TOTALES {total_cantidad} pzas. / {"$" + new Intl.NumberFormat("en-US").format(total_general)}
              </h4>
              </Col> */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editOrdenes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>Editar Articulos OC {numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US").format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">SKU</Label>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Nombre</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2" title="Dias de produccion de cada articulo en ESTA orden (no cambia el catalogo)">
                Dias prod.
              </Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col> */}
            {/* <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Precio USD</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden
            .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
            .map((ao) => (
              <div key={ao.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={ao.articulos}
                      required
                      onChange={(event) => {
                        BuscaArticuloExistentes(ao.id, event);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {articulos
                        .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.SKU}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="nombre"
                      type="text"
                      placeholder="nombre"
                      value={ao.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={ao.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentesCantidad(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="diasProduccion"
                      type="number"
                      min="0"
                      step="1"
                      title={`Solo para esta orden. Catalogo: ${ao.diasProduccionCatalogo || 0} dias`}
                      value={ao.diasProduccion}
                      style={
                        Number(ao.diasProduccion) !== Number(ao.diasProduccionOriginal)
                          ? { borderColor: "#f59e0b", background: "#fffbeb" }
                          : {}
                      }
                      onChange={(event) => cambiaDiasProduccion(ao.id, event.target.value, false)}
                    />
                  </Col>
                  {/* <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="embarcado"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="embarcado"
                      value={ao.embarcado}
                      required
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="pendiente_embarcar"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="pendiente_embarcar"
                      value={ao.pendiente_embarcar}
                      required
                      disabled
                    />
                  </Col> */}

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={ao.precio}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={ao.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={3}>
                  <Input
                    // bsSize="sm"
                    name="nombre"
                    type="text"
                    placeholder="nombre"
                    value={inputField.nombre}
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="diasProduccion"
                    type="number"
                    min="0"
                    step="1"
                    title="Solo para esta orden (se propone el del catalogo)"
                    value={inputField.diasProduccion === undefined ? "" : inputField.diasProduccion}
                    disabled={!inputField.articulos || inputField.articulos === "0"}
                    onChange={(event) => cambiaDiasProduccion(inputField.id, event.target.value, true)}
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col> */}

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    title="Quitar renglon"
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    title="Agregar renglon"
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US").format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <span style={{ fontSize: 11, color: "#64748b", marginRight: "auto" }}>
            Los dias de produccion se guardan solo en esta orden; el catalogo del articulo no cambia.
          </span>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulosPI}
        toggle={toggleEditArticulosPI}
      >
        <ModalHeader toggle={toggleEditArticulosPI}>
          <h4>Subir PI OC #{numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US").format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: 10,
              padding: 12,
              marginBottom: 12,
              background: "#f8fafc",
            }}
          >
            <Row className="align-items-end">
              <Col md={3}>
                <Label className="mr-sm-2" style={{ fontSize: 12 }}>
                  Numero de proforma
                </Label>
                <Input
                  bsSize="sm"
                  type="text"
                  placeholder="PI del proveedor"
                  value={numeroProforma}
                  onChange={(e) => setNumeroProforma(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2" style={{ fontSize: 12 }}>
                  Tiempo estimado de envio (dias)
                </Label>
                <Input
                  bsSize="sm"
                  type="number"
                  min="0"
                  value={diasEnvio}
                  onChange={(e) => setDiasEnvio(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row className="align-items-end">
              <Col md={5}>
                <Label className="mr-sm-2" style={{ fontSize: 12 }}>
                  Archivo(s) de la proforma (PDF o imagen)
                </Label>
                <SelectorArchivos
                  archivos={archivoProforma}
                  onChange={setArchivoProforma}
                  deshabilitado={subiendoArchivo}
                />
              </Col>
              <Col md={7}>
                {/* Las proformas que de verdad tiene la orden (no la busqueda vieja en Cloudinary) */}
                {(() => {
                  const proformas = ((comments.find((x) => x._id === idEdit) || {}).archivos || []).filter(
                    (a) => a.tipo === "Proforma"
                  );
                  return proformas.length ? (
                    <div style={{ fontSize: 12 }}>
                      <b>Proformas en esta orden:</b>
                      {proformas.map((a, i) => (
                        <div key={a.public_id || i}>
                          <a href={a.url} target="_blank" rel="noreferrer">
                            <i class="fas fa-paperclip"></i> {a.nombre}
                          </a>{" "}
                          <span style={{ color: "#94a3b8" }}>{a.fecha}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>Esta orden no tiene proforma todavia</div>
                  );
                })()}
              </Col>
            </Row>
            <div style={{ textAlign: "right", marginTop: 10 }}>
              <Button
                size="sm"
                color="success"
                onClick={guardaProforma}
                disabled={subiendoArchivo}
                title="Guarda el numero, los dias de envio y los archivos de la proforma"
              >
                {subiendoArchivo ? "Guardando..." : "Guardar proforma"}
              </Button>
            </div>
          </div>

          <Label className="mr-sm-2" style={{ fontSize: 12 }}>
            Subir Excel de la PI para actualizar cantidades y precios
          </Label>
          <Row>
            <Col>
              <Input
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
              <div style={{ fontSize: 11, color: "#94a3b8" }}>
                Usa el Excel que descargas con el boton PI I: trae la columna
                IdItem que amarra cada renglon. Tambien funciona con una columna
                SKU.
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">CBM</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Precio Original</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={ao.articulos}
                    required
                    disabled
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={ao.cantidad}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cbm"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="cbm"
                    value={ao.cbm}
                    disabled
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="embarcado"
                    value={ao.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="pendiente_embarcar"
                    value={ao.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col> */}
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precioOriginal"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="PrecioOriginal"
                    value={ao.precioOriginal}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={ao.precio}
                    style={
                      ao.precioOriginal < ao.precio
                        ? { backgroundColor: "#ed8c8c" } // rojo cuando sube
                        : ao.precio < ao.precioOriginal
                        ? { backgroundColor: "#a4e6a4" } // verde cuando baja
                        : {}
                    }
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={ao.total}
                    disabled
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {/* {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.SKU}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    title="Quitar renglon"
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    title="Agregar renglon"
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))} */}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US").format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="md" isOpen={modalArchivos} toggle={toggleArchivos}>
        <ModalHeader toggle={toggleArchivos}>
          <h4>Archivos de la OC {ocArchivos.numero}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: 12, color: "#64748b" }}>
            {ocArchivos.proveedores} · {ocArchivos.fecha}
          </div>
          <br />
          {listaArchivos.length ? (
            <Table size="sm" borderless>
              <thead>
                <tr>
                  <th style={{ fontSize: 12 }}>Archivo</th>
                  <th style={{ fontSize: 12 }}>Tipo</th>
                  <th style={{ fontSize: 12 }}>Fecha</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {listaArchivos.map((f, i) => (
                  <tr key={f.public_id || i}>
                    <td style={{ fontSize: 12 }}>{f.nombre}</td>
                    <td style={{ fontSize: 12 }}>
                      {f.tipo === "Proforma" ? (
                        <Badge color="success" pill>
                          Proforma
                        </Badge>
                      ) : (
                        <span style={{ color: "#64748b" }}>{f.tipo || "Otro"}</span>
                      )}
                    </td>
                    <td style={{ fontSize: 12 }}>{f.fecha}</td>
                    <td>
                      <a
                        href={f.url}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-info btn-sm"
                      >
                        Abrir
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div style={{ fontSize: 12, color: "#94a3b8" }}>
              Esta orden no tiene archivos todavia.
            </div>
          )}
          <br />
          <Label className="mr-sm-2" style={{ fontSize: 12 }}>
            Agregar archivos o una carpeta
          </Label>
          <SelectorArchivos
            archivos={archivoNuevo}
            onChange={setArchivoNuevo}
            deshabilitado={subiendoArchivo}
          />
          <Label className="mr-sm-2 mt-2" style={{ fontSize: 12 }}>
            Tipo de archivo
          </Label>
          <Input
            bsSize="sm"
            type="select"
            value={tipoArchivo}
            onChange={(e) => setTipoArchivo(e.target.value)}
          >
            <option value="Otro">Otro</option>
            <option value="Proforma">Proforma</option>
            <option value="Ficha tecnica">Ficha tecnica</option>
            <option value="Cotizacion">Cotizacion</option>
          </Input>
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>
            Solo lo marcado como <b>Proforma</b> cuenta como proforma de la orden.
          </div>
          {tipoArchivo === "Proforma" && user.oc_proforma ? (
            <Row className="mt-2">
              <Col md={7}>
                <Label className="mr-sm-2" style={{ fontSize: 12 }}>
                  Numero de proforma
                </Label>
                <Input
                  bsSize="sm"
                  type="text"
                  placeholder="PI del proveedor"
                  value={numeroProformaArch}
                  onChange={(e) => setNumeroProformaArch(e.target.value)}
                />
              </Col>
              <Col md={5}>
                <Label className="mr-sm-2" style={{ fontSize: 12 }}>
                  Dias de envio
                </Label>
                <Input
                  bsSize="sm"
                  type="number"
                  min="0"
                  value={diasEnvioArch}
                  onChange={(e) => setDiasEnvioArch(e.target.value)}
                />
              </Col>
            </Row>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={subeArchivoOC}
            disabled={subiendoArchivo}
          >
            {subiendoArchivo
              ? "Subiendo..."
              : archivoNuevo.length > 1
              ? `Subir ${archivoNuevo.length} archivos`
              : !archivoNuevo.length && tipoArchivo === "Proforma" && user.oc_proforma
              ? "Guardar"
              : "Subir"}
          </Button>
          <Button color="secondary" onClick={toggleArchivos}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProduccion} toggle={toggleProduccion}>
        <ModalHeader toggle={toggleProduccion}>
          <h4>Produccion OC {ocProduccion.numero}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: 12, color: "#64748b" }}>
            {ocProduccion.proveedores} · Compromiso de embarque{" "}
            {ocProduccion.fecha_compromiso || "sin fecha"}
          </div>
          <br />
          <h6 style={{ fontWeight: 700, fontSize: 13, color: "#334155", marginBottom: 2 }}>
            ESTIMADAS
          </h6>
          <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 8 }}>
            Lo que promete el proveedor. Pueden ser futuras.
          </div>
          <Label className="mr-sm-2">Inicio estimado</Label>
          <Input
            bsSize="sm"
            type="date"
            value={inicioProduccion}
            onChange={(e) => cambiaInicioEstimado(e.target.value)}
          />
          <Label className="mr-sm-2 mt-2" title="Dias de produccion de esta orden (no cambia el catalogo)">
            Dias de produccion
          </Label>
          <Input
            bsSize="sm"
            type="number"
            min="0"
            step="1"
            placeholder="Ej. 45"
            title="Al capturarlos, el fin estimado se calcula solo: inicio + dias"
            value={diasProd}
            onChange={(e) => cambiaDiasProd(e.target.value)}
          />
          <Label className="mr-sm-2 mt-2">Fin estimado</Label>
          <Input
            bsSize="sm"
            type="date"
            value={finProduccion}
            onChange={(e) => {
              setFinProduccion(e.target.value);
              setFinManual(true);
            }}
          />
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
            {finManual && inicioProduccion && Number(diasProd) > 0 ? (
              <>
                Capturado a mano.{" "}
                <span
                  style={{ color: "#2563eb", cursor: "pointer" }}
                  title="Poner inicio estimado + dias de produccion"
                  onClick={() => {
                    setFinManual(false);
                    setFinProduccion(sumaDias(inicioProduccion, diasProd));
                  }}
                >
                  Calcular con los dias ({sumaDias(inicioProduccion, diasProd)})
                </span>
              </>
            ) : Number(diasProd) > 0 ? (
              "Se calcula con inicio estimado + dias; lo puedes cambiar."
            ) : null}
          </div>
          <hr />
          <h6 style={{ fontWeight: 700, fontSize: 13, color: "#334155", marginBottom: 2 }}>
            REALES
          </h6>
          <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 8 }}>
            Solo cuando ya paso de verdad. No se aceptan fechas futuras.
          </div>
          <Label className="mr-sm-2">Inicio real</Label>
          <Input
            bsSize="sm"
            type="date"
            max={new Date().toISOString().slice(0, 10)}
            value={inicioReal}
            onChange={(e) => setInicioReal(e.target.value)}
          />
          <Label className="mr-sm-2 mt-2">Fin real</Label>
          <Input
            bsSize="sm"
            type="date"
            max={new Date().toISOString().slice(0, 10)}
            value={finReal}
            onChange={(e) => setFinReal(e.target.value)}
          />
          {atrasoProduccion({
            fechaInicioProduccion: inicioProduccion,
            fechaFinProduccion: finProduccion,
            fechaInicioReal: inicioReal,
            fechaFinReal: finReal,
          }) ? (
            <div
              style={{
                marginTop: 10,
                padding: "6px 10px",
                background: "#fef3c7",
                color: "#92400e",
                borderRadius: 6,
                fontSize: 12,
              }}
            >
              ATRASO ·{" "}
              {atrasoProduccion({
                fechaInicioProduccion: inicioProduccion,
                fechaFinProduccion: finProduccion,
                fechaInicioReal: inicioReal,
                fechaFinReal: finReal,
              })}
            </div>
          ) : null}
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
            Deja la fecha vacia si todavia no la tienes.
          </div>
          <hr />
          <Label className="mr-sm-2">Observaciones de produccion</Label>
          <Input
            bsSize="sm"
            type="textarea"
            rows={3}
            maxLength={2000}
            placeholder="Ej. el proveedor movio la fecha por falta de material, arte pendiente..."
            value={obsProduccion}
            onChange={(e) => setObsProduccion(e.target.value)}
          />
          <hr />
          <Label
            check
            style={{ marginLeft: 20 }}
            title={user.oc_cargaLista ? "El proveedor ya tiene la mercancia lista. Avisa a Oyuki para el booking" : "Necesitas el permiso de carga lista"}
          >
            <Input
              type="checkbox"
              checked={cargaListaProd}
              disabled={!user.oc_cargaLista}
              onChange={(e) => setCargaListaProd(e.target.checked)}
            />{" "}
            <b>Carga lista</b>
            {ocProduccion.listoEmbarque === "Si" && ocProduccion.fechaListoEmbarque ? (
              <span style={{ fontSize: 11, color: "#64748b" }}> desde {ocProduccion.fechaListoEmbarque}</span>
            ) : null}
          </Label>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardaProduccion}>
            Guardar
          </Button>
          <Button color="danger" onClick={toggleProduccion}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoOrdenesCompra;
